<template>
  <tbody :class="[showDetail ? 'isActive' : '', 'tbody']" v-if="trip">
    <tr>
      <!-- <td style="width: 40px">
        <v-checkbox
          v-model="trip.selected"
          style="padding: 0; float: left; width: 30px"
        />
      </td> -->
      <td @click="showDetail = !showDetail">
        <span v-if="trip.clientCargos && trip.clientCargos.length > 0 && trip.clientCargos[0].cargos && trip.clientCargos[0].cargos.length > 0 && trip.clientCargos[0].cargos[0].lr">
          {{ trip.clientCargos[0].cargos[0].lr.number }}
        </span>
      </td>
      <td @click="showDetail = !showDetail">{{ trip.tripNo }}</td>
      <td @click="showDetail = !showDetail">
        <v-chip class="ma-2" x-small :color="statusColor()">{{
          trip.statusStr
        }}</v-chip>
        <v-chip x-small color="lime lighten-1" fab v-if="trip.invoiceNos"
          >{{trip.invoiceNos}}</v-chip
        >
      </td>
      <td @click="showDetail = !showDetail">
        <span v-if="trip.vendorEntityName">
          <div v-if="trip.vendorEntityName.length < 12">
            {{ trip.vendorEntityName }}
          </div>
          <div v-else>{{ trip.vendorEntityName.substring(0, 12) + ".." }}</div>
        </span>
      </td>
      <td @click="showDetail = !showDetail">
        <!-- <span v-if="trip.clientName">
          <div v-if="trip.clientName.length < 12">
            {{ trip.clientName }}
          </div>
          <div v-else>{{ trip.clientName.substring(0, 12) + ".." }}</div>
        </span> -->
        <span v-if="trip.clientName">
          <div >{{ formattedClientName(trip.clientName) }}</div>
        </span>
      </td>
      <td @click="showDetail = !showDetail">
        <span v-if="trip.supplierName">
          <div v-if="trip.supplierName.length < 12">
            {{ trip.supplierName }}
          </div>
          <div v-else>{{ trip.supplierName.substring(0, 12) + ".." }}</div>
        </span>
      </td>
      <!-- <td @click="showDetail = !showDetail">
        <span v-if="trip.bodyType">
          <div v-if="trip.bodyType.length < 10">
            {{ trip.bodyType }}
          </div>
          <div v-else>{{ trip.bodyType.substring(0, 10) + ".." }}</div>
        </span>
      </td> -->
      <td @click="showDetail = !showDetail">{{ trip.truckTypeStr }}</td>
      <td @click="showDetail = !showDetail">
        {{ trip.startTime | moment("DD MMM YY") }} {{ trip.updateAt | moment("DD MMM YY") }}
      </td>
      <td @click="showDetail = !showDetail">
        {{ trip.vehicle != null ? trip.vehicle.regNo : "" }}
      </td>
      <!-- <td @click="showDetail = !showDetail">
        {{ trip.driver != null ? trip.driver.name : null }}
      </td> -->
      <td @click="showDetail = !showDetail">
        <span v-if="srcCity">
          <div v-if="srcCity.length < 10">
            {{ srcCity }}
          </div>
          <div v-else>{{ srcCity.substring(0, 10) + ".." }}</div>
        </span>
      </td>
      <td @click="showDetail = !showDetail">
        <span v-if="dstCity">
          <div v-if="dstCity.length < 10">
            {{ dstCity }}
          </div>
          <div v-else>{{ dstCity.substring(0, 10) + ".." }}</div>
        </span>
      </td>
      <td @click="showDetail = !showDetail" class="text-right" v-if="$ha(750)">
        <span v-if="margin == null || margin >= 0">{{ clientDue }}</span>
        <v-chip
          class="ma-2"
          x-small
          dark
          color="red accent-3"
          v-if="margin != null && margin < 0"
        >
         {{ clientDue }}
        </v-chip>
      </td>
      <td @click="showDetail = !showDetail" class="text-right" v-if="$ha(750)">
        <span v-if="margin == null || margin >= 0">{{ supplierDue }}</span>

        <v-chip
          class="ma-2"
          x-small
          dark
          color="red accent-3"
          v-if="margin != null && margin < 0"
        >
          {{ supplierDue }}
        </v-chip>
      </td>
      <td @click="showDetail = !showDetail">{{ trip.tagStr }}</td>
    </tr>
    <tr v-if="showDetail" style="background-color: #e0f2f1">
      <td colspan="15" style="text-align: -webkit-center">
        <table style="width: 100%">
          <tr>
            <td colspan="3">
              Entity : {{ trip.vendorEntityName }}
              <br v-if="trip.createdBy" />
              <br v-if="trip.createdBy" />
              {{ trip.createdBy ? "Created By-" + trip.createdBy : "" }}
              <br v-if="trip.updateBy" />
              {{ trip.updateBy ? "Updated By-" + trip.updateBy : "" }}
              <br v-if="trip.deletedBy" />
              <br v-if="trip.deletedBy" />
              <v-chip v-if="trip.deletedBy" x-small color="error">{{
                "Deleted By-" + trip.deletedBy
              }}</v-chip>
            </td>
            <td colspan="3">
              <small class="text-body-2">
                <v-icon color="green">mdi-map-marker</v-icon>
                {{ trip.startTime | moment("HH:mm DD MMM YYYY") }}
              </small>
              <br />
              <small class="text-body-2" v-if="trip.endTime">
                <v-icon color="red">mdi-map-marker</v-icon>
                {{ trip.endTime | moment("HH:mm DD MMM YYYY") }}
              </small>
              <br />
              <!-- <small class="text-body-2">
                <v-icon color="green">mdi-map-marker</v-icon>
                {{ trip.src && trip.src.addressLine ? (trip.src.addressLine.length > 30 ? trip.src.addressLine.substring(0,29) + "..." : "") : "" }}
                {{ trip.src ? trip.src.city : "" }}
              </small>
              <br />
              <small class="text-body-2">
                <v-icon color="red">mdi-map-marker</v-icon>
                {{ trip.dst && trip.dst.addressLine ? (trip.dst.addressLine.length > 30 ? trip.dst.addressLine.substring(0,29) + "..." : "") : "" }}
                {{ trip.dst ? trip.dst.city : "" }}
              </small> -->
            </td>
            <td colspan="3">
              <table style="width: 70%">
                <tr>
                  <td>
                    <v-row>
                      <v-col cols="12" sm="3" md="3" lg="3">
                        <v-img
                          v-if="trip.vehicle"
                          :src="trip.vehicle.pic"
                          height="40"
                          width="60"
                        />
                      </v-col>
                      <v-col cols="12" sm="9" md="9" lg="9">
                        <v-row
                          v-if="trip.vehicle"
                          style="
                            align-self: center;
                            height: 37px;
                            border: 1px solid #d9d9d9;
                            border-radius: 7px;
                            align-content: space-evenly;
                            margin-bottom: -7px;
                            background: #f6f6f6;
                          "
                        >
                          <v-col
                            cols="12"
                            sm="5"
                            md="5"
                            lg="5"
                            v-if="trip.vehicle"
                            >{{ trip.vehicle.regNo }}</v-col
                          >
                          <v-col
                            cols="12"
                            sm="7"
                            md="7"
                            lg="7"
                            v-if="trip.vehicle"
                            >{{ trip.vehicle.truckTypeStr }}</v-col
                          >
                        </v-row>
                        <v-row>
                          <v-chip
                            small
                            color="green"
                            dark
                            v-if="
                              trip.vehicle != null &&
                              trip.vehicle.corp_id &&
                              !trip.vehicle.marketVeh &&
                              trip.vendor_id != trip.vehicle.corp_id
                            "
                            >{{ $i18n.t("Supplier Vehicle") }} -
                            {{ trip.vehicle.corpName }}</v-chip
                          >
                          <v-chip
                            small
                            color="cyan"
                            dark
                            v-if="
                              trip.vehicle != null &&
                              trip.vendor_id == trip.vehicle.corp_id
                            "
                            >{{ $i18n.t("Own Vehicle") }}</v-chip
                          ><v-chip
                            small
                            color="cyan"
                            dark
                            v-if="
                              trip.vehicle != null && trip.vehicle.marketVeh
                            "
                            >{{ $i18n.t("Market Vehicle") }}</v-chip
                          >
                        </v-row>
                      </v-col>
                    </v-row>
                    <!-- <z-vehicle-select
                      :value="trip.vehicle"
                      :label="$i18n.t('Vehicle')"
                      @input="onVehicleChange"
                      :disabled="!trip.showVehicleAssign"
                      style="width: 80%; float: left"
                    />
                    <v-tooltip top style="float: left">
                      <template v-slot:activator="{ tooltip }">
                        <z-confirm-button
                          @click="unassignVehicle(trip)"
                          fab
                          x-small
                          color="error"
                          text
                          v-on="tooltip"
                          :message="
                            $i18n.t(
                              'Are you sure you want to unassign vehicle?'
                            )
                          "
                          class="mt-3"
                        >
                          <v-icon>mdi-minus-circle-outline</v-icon>
                        </z-confirm-button>
                      </template>
                      <span>{{ $i18n.t("Unassign Vehicle") }}</span>
                    </v-tooltip> -->
                  </td>
                </tr>
                <tr style="background-color: transparent">
                  <td>
                    <v-row>
                      <v-col cols="12" sm="3" md="3" lg="3">
                        <v-img
                          v-if="trip.driver"
                          :src="trip.driver.pic"
                          height="40"
                          width="60"
                        />
                      </v-col>
                      <v-col cols="12" sm="9" md="9" lg="9">
                        <v-row
                          v-if="trip.driver"
                          style="
                            align-self: center;
                            height: 37px;
                            border: 1px solid #d9d9d9;
                            border-radius: 7px;
                            align-content: space-evenly;
                            margin-bottom: -7px;
                            background: #f6f6f6;
                          "
                        >
                          <v-col
                            cols="12"
                            sm="4"
                            md="4"
                            lg="4"
                            v-if="trip.driver"
                            >{{ trip.driver.name }}</v-col
                          >
                          <v-col
                            cols="12"
                            sm="6"
                            md="6"
                            lg="6"
                            v-if="trip.driver"
                            >{{ trip.driver.countryCode }}
                            {{ trip.driver.phone }}</v-col
                          >
                        </v-row>

                        <v-row>
                          <v-chip
                            small
                            color="green"
                            dark
                            v-if="
                              trip.driver != null &&
                              trip.driver.driverOf &&
                              !trip.driver.marketDriver &&
                              trip.vendor_id != trip.driver.driverOf
                            "
                            >{{ $i18n.t("Supplier Driver") }} -
                            {{ trip.driver.driverOwner }}</v-chip
                          >
                          <v-chip
                            small
                            color="cyan"
                            dark
                            v-if="
                              trip.driver != null &&
                              trip.vendor_id == trip.driver.driverOf
                            "
                            >{{ $i18n.t("Own Driver") }}</v-chip
                          ><v-chip
                            small
                            color="cyan"
                            dark
                            v-if="
                              trip.driver != null && trip.driver.marketDriver
                            "
                            >{{ $i18n.t("Market Driver") }}</v-chip
                          >
                        </v-row>
                      </v-col>
                    </v-row>
                    <!-- <z-driver-select
                      v-model="trip.driver"
                      :label="$i18n.t('Driver')"
                      @input="onDriverChange"
                      :disabled="!trip.showVehicleAssign"
                    /> -->
                  </td>
                </tr>
              </table>
            </td>
            <td colspan="3" v-if="$ha(750)">
              <p style="margin: 0px">
                {{ $i18n.t("Client Amount") }} : {{ clientAmount }}
              </p>
              <p>{{ $i18n.t("Collected Amount") }} : {{ clientAmountPaid?clientAmountPaid:0 }}</p>
              <p v-if="supplierAmount != null" style="margin: 0px">
                {{ $i18n.t("Supplier Amount") }} : {{ supplierAmount }}
              </p>
              <p v-if="supplierDue != null">
                {{ $i18n.t("Supplier Amount Due") }} : {{ supplierDue }}
              </p>
              <p v-if="totalExpenses != null">
                {{ $i18n.t("Expenses") }} : {{ totalExpenses }}
              </p>
              <p v-if="margin != null">
                {{ $i18n.t("Total Margin") }} : {{ margin }}
              </p>
            </td>
            <td colspan="3">
              <v-btn
                text
                fab
                small
                color="blue"
                @click="onClick()"
                @click.native.stop
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>

              <!-- <v-btn
                text
                fab
                small
                color="teal"
                :title="$i18n.t('Print Invoice')"
                @click="invDownload()"
                v-if="trip.showPrintInvoice"
              >
                <v-icon>mdi-printer</v-icon>
              </v-btn> -->

              <!-- <v-btn
                text
                fab
                small
                color="teal lighten-2"
                :title="$i18n.t('Email Invoice')"
                @click="invEmail()"
                v-if="trip.showPrintInvoice"
              >
                <v-icon>mdi-email</v-icon>
              </v-btn> -->

              <z-confirm-button
                text
                fab
                small
                color="red lighten-2"
                :title="$i18n.t('Cancel Trip')"
                @click="cancelTrip(trip)"
                :message="$i18n.t('Do you want to cancel this trip ?')"
                v-if="trip.showCancel"
              >
                <v-icon>mdi-cancel</v-icon>
              </z-confirm-button>

              <z-confirm-button
                text
                fab
                small
                color="red lighten-2"
                :title="$i18n.t('Delete Trip')"
                @click="deleteTrip(trip)"
                :message="$i18n.t('Do you want to cancel this trip ?')"
                v-if="trip.showDelete"
              >
                <v-icon>mdi-trash-can-outline</v-icon>
              </z-confirm-button>
                 <z-confirm-button
            text
            fab
            small
            color="grey"
            :title="$i18n.t('Copy Trip')"
            
            @click="copiedTripPage(trip._id)" 
            :message="$i18n.t('Do you want to copy this trip ?')"
            
          >
            <v-icon>mdi-content-copy</v-icon>
          </z-confirm-button>

              <v-btn
                text
                fab
                small
                color="teal lighten-2"
                :title="$i18n.t('Mark Completed')"
                @click="markCompleted(trip)"
                v-if="trip.showMarkCompleted && trip.showSave"
              >
                <v-icon>mdi-gavel</v-icon>
              </v-btn>

              <v-btn
                text
                fab
                small
                :color="
                  trip.status == 3
                    ? 'blue lighten-2'
                    : trip.status == 4
                    ? 'red lighten-2'
                    : trip.status == 5
                    ? 'red accent-3'
                    : 'purple'
                "
                :title="$i18n.t('Update Trip Details')"
                @click="showStartStopDialog = true"
                v-if="trip.status > 2 && trip.showSave"
              >
                <v-icon v-if="trip.status == 3">mdi-play</v-icon>
                <v-icon v-if="trip.status == 4 || trip.status == 5"
                  >mdi-play-pause</v-icon
                >
                <v-icon
                  v-if="
                    trip.status != 3 && trip.status != 4 && trip.status != 5
                  "
                  >mdi-check-all</v-icon
                >
              </v-btn>

              <!-- <v-btn
                text
                fab
                small
                color="grey"
                :title="$i18n.t('Create Invoice')"
                @click="createInvoiceDialog()"
                v-if="trip.showMakeInvoice"
              >
                <v-icon>mdi-receipt</v-icon>
              </v-btn> -->

              <!-- <v-menu
                offset-y
                v-if="
                  trip.showPrintInvoice ||
                  trip.showInvoice ||
                  trip.showInvCreate ||
                  trip.showInvVerify ||
                  trip.showInvSubmit ||
                  trip.showInvDelete
                "
              >
                <template v-slot:activator="{ on }">
                  <v-btn text fab v-on="on" color="green" small>
                    <v-icon>mdi-receipt</v-icon>
                  </v-btn>
                </template>
                <v-list v-if="trip.showInvoice">
                  <v-btn
                    text
                    target="_blank"
                    :to="'/sales/invoice/' + trip.invoice_id"
                    ><v-icon>mdi-eye</v-icon>
                    {{ $i18n.t("Show Invoice") }}</v-btn
                  >
                </v-list>
                <v-list v-if="trip.showInvoice">
                  <v-btn text @click="recreateInvoice()"
                    ><v-icon>mdi-refresh</v-icon
                    >{{ $i18n.t("Recreate") }}</v-btn
                  >
                </v-list>
                <v-list v-if="trip.showInvoice">
                  <v-btn text @click="invEmail()"
                    ><v-icon>mdi-email</v-icon
                    >{{ $i18n.t("Email Invoice") }}</v-btn
                  >
                </v-list>
                <v-list v-if="trip.showInvCreate">
                  <v-btn text @click="changeInvoiceStatus(0)"
                    ><v-icon>mdi-exclamation-thick</v-icon
                    >{{ $i18n.t("Mark Unverified") }}</v-btn
                  >
                </v-list>
                <v-list v-if="trip.showInvVerify">
                  <v-btn text @click="changeInvoiceStatus(1)"
                    ><v-icon>mdi-check</v-icon
                    >{{ $i18n.t("Mark Verified") }}</v-btn
                  >
                </v-list>
                <v-list v-if="trip.showPrintInvoice">
                  <v-btn text @click="invDownload()"
                    ><v-icon>mdi-printer</v-icon>
                    {{ $i18n.t("Print Invoice") }}</v-btn
                  >
                </v-list>
                <v-list v-if="trip.showInvDelete">
                  <z-confirm-button
                    text
                    :title="$i18n.t('Delete Trip')"
                    @click="deleteInvoice()"
                    :message="$i18n.t('Do you want to cancel this trip ?')"
                  >
                    <v-icon>mdi-trash-can-outline</v-icon>
                    {{ $i18n.t("Delete Invoice") }}
                  </z-confirm-button>
                </v-list>
              </v-menu> -->
            </td>
          </tr>
        </table>
       <!--  <template v-if="trip.clientCargos && trip.clientCargos.length > 0">
          <table style="width: 95%; background: #e0f2f1; border: 1px solid #b2dfdb"
            v-for="(clients, index2) in trip.clientCargos" :key="index2" class="mb-5">
            <tr style="background: #b2dfdb" :key="index2">
              <th>GRN No</th>
              <th>Material</th>
              <th>Ewaybill no</th>
              <th>Goods Invoice No</th>
              <th>Goods Invoice Value</th>
              <th>LR Date</th>
              <th>Weight</th>
              <th>Length</th>
              <th>Units</th>
            </tr>
            <tr v-for="(cargo, index) in clients.cargos" :key="index">
              <td class="text-center">{{ cargo.lr ? cargo.lr.number : "" }}</td>
              <td class="text-center">{{ cargo.material }}</td>
              <td class="text-center">
                {{ cargo.lr ? cargo.lr.wayBillNo : "" }}
              </td>
              <td class="text-center">
                {{ cargo.lr ? cargo.lr.invoiceNo : "" }}
              </td>
              <td class="text-center">{{ cargo.lr ? cargo.lr.amount : "" }}</td>
              <td class="text-center">
                {{ cargo.lr ? formatDate(cargo.lr.date) : "" }}
              </td>
              <td class="text-center">
                {{ cargo.weight }}
                {{
                cargo.weightUnit == 0 ? "KG" : cargo.weightUnit == 1 ? "T" : ""
                }}
              </td>
              <td class="text-center">
                {{ cargo.length }}
                {{
                cargo.measureUnit == 0
                ? "CM"
                : cargo.measureUnit == 1
                ? "Inch"
                : cargo.measureUnit == 2
                ? "Feet"
                : cargo.measureUnit == 3
                ? "Meter"
                : ""
                }}
              </td>
              <td class="text-center">
                {{ cargo.units }}
              </td>
            </tr>
        
          </table>
        
        </template> -->

        <table
          style="width: 99%; background: #e0f2f1; border: 1px solid #b2dfdb"
          v-if="trip.clientCargos && trip.clientCargos.length > 0"
          class="mb-5"
        >
      
        <template v-for="(clients, i) in trip.clientCargos" >
          <tr style="background: rgb(92 188 179); height:25px;" :key="i+'header0'+trip._id">
            <th colspan="5">Client Name : {{ trip['clientNameMap'][clients['client_id']] }} | Entity : {{ trip['clientEntityMap'][clients['clientEntity_id']] }}</th>
            <th colspan="1">Total : {{clients['billing'] && clients['billing']['fare'] ? clients['billing']['fare']['total'] : ""}}</th>
            <th colspan="1">Paid : {{clients['billing'] && clients['billing']['fare'] ? clients['billing']['fare']['amountPaid'] : ""}}</th>
            <th colspan="4">Amount Due : {{clients['billing'] && clients['billing']['fare'] ? clients['billing']['fare']['pending'] : ""}}</th>
          </tr>
          
          <tr style="background: #b2dfdb" :key="i+'header1'+trip._id">
            <th>GRN No</th>
            <th>Pickup</th>
            <th>Drop</th>
            <th>Material</th>
            <th>Ewaybill no</th>
            <th>Goods Invoice No</th>
            <th>Goods Invoice Value</th>
            <th>LR Date</th>
            <th>Weight</th>
            <th>Length</th>
            <th>Units</th>
          </tr>
          <tr v-for="(cargo, index) in clients.cargos" :key="i+'header0'+trip._id+index">
              <td class="text-center">{{ cargo.lr ? cargo.lr.number : "" }}</td>
              <td class="text-center">{{ cargo.src ? cargo.src.city : "" }}</td>
              <td class="text-center">{{ cargo.dst ? cargo.dst.city : "" }}</td>
              <td class="text-center">{{ cargo.material }}</td>
              <td class="text-center">
                {{ cargo.lr ? cargo.lr.wayBillNo : "" }}
              </td>
              <td class="text-center">
                {{ cargo.lr ? cargo.lr.invoiceNo : "" }}
              </td>
              <td class="text-center">{{ cargo.lr ? cargo.lr.amount : "" }}</td>
              <td class="text-center">
                {{ cargo.lr ? formatDate(cargo.lr.date) : "" }}
              </td>
              <td class="text-center">
                {{ cargo.weight }}
                {{
                cargo.weightUnit == 0 ? "KG" : (cargo.weightUnit == 2 ? "PCS" : (cargo.weightUnit == 1 ? "T" : ""))
                }}
              </td>
              <td class="text-center">
                {{ cargo.length }}
                {{
                cargo.measureUnit == 0
                ? "CM"
                : cargo.measureUnit == 1
                ? "Inch"
                : cargo.measureUnit == 2
                ? "Feet"
                : cargo.measureUnit == 3
                ? "Meter"
                : ""
                }}
              </td>
              <td class="text-center">
                {{ cargo.units }}
              </td>
            </tr>
        </template>
        </table>
        
        
          
         
        
        <!-- <table
          style="width: 95%; background: #e0f2f1; border: 1px solid #b2dfdb"
          v-if="trip.cargos && trip.cargos.length > 0"
          class="mb-5"
        >
          <tr style="background: #b2dfdb">
            <th>GRN No</th>
            <th>Material</th>
            <th>Ewaybill no</th>
            <th>Goods Invoice No</th>
            <th>Goods Invoice Value</th>
            <th>LR Date</th>
            <th>Weight</th>
            <th>Length</th>
            <th>Units</th>
          </tr>
          <tr v-for="(cargo, index) in trip.cargos" :key="index">
            <td class="text-center">{{ cargo.lr ? cargo.lr.number : "" }}</td>
            <td class="text-center">{{ cargo.material }}</td>
            <td class="text-center">
              {{ cargo.lr ? cargo.lr.wayBillNo : "" }}
            </td>
            <td class="text-center">
              {{ cargo.lr ? cargo.lr.invoiceNo : "" }}
            </td>
            <td class="text-center">{{ cargo.lr ? cargo.lr.amount : "" }}</td>
            <td class="text-center">
              {{ cargo.lr ? formatDate(cargo.lr.date) : "" }}
            </td>
            <td class="text-center">
              {{ cargo.weight }}
              {{
                cargo.weightUnit == 0 ? "KG" : cargo.weightUnit == 1 ? "T" : ""
              }}
            </td>
            <td class="text-center">
              {{ cargo.length }}
              {{
                cargo.measureUnit == 0
                  ? "CM"
                  : cargo.measureUnit == 1
                  ? "Inch"
                  : cargo.measureUnit == 2
                  ? "Feet"
                  : cargo.measureUnit == 3
                  ? "Meter"
                  : ""
              }}
            </td>
            <td class="text-center">
              {{ cargo.units }}
            </td>
          </tr>
        </table> -->
      </td>
    </tr>

    <v-dialog v-model="vehicleUpdate" color="white" width="400">
      <v-card>
        <v-card-text>{{ vehicleUpdateText }}</v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="green"
            text
            small
            @click="onVehicleUpdateYes(true)"
            v-if="driverUpdate"
            :loading="loading"
          >
            <span>{{ $i18n.t("To Trip Only") }}</span>
          </v-btn>
          <v-btn
            color="green"
            text
            small
            @click="onVehicleUpdateYes(false)"
            v-if="driverUpdate"
            :loading="loading"
          >
            <span>{{ $i18n.t("To Vehicle") }}</span>
          </v-btn>
          <v-btn
            color="green"
            text
            small
            @click="onVehicleUpdateYes()"
            v-if="!driverUpdate"
            :loading="loading"
          >
            <v-icon>mdi-check</v-icon>
          </v-btn>
          <v-btn
            color="red"
            text
            fab
            small
            v-bind="attrs"
            @click="onVehicleUpdateNo()"
            :loading="loading"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <duty-close
      :trip="trip"
      :showDialog="showDutyCloseDialog"
      @dutyCloseDilogClose="dutyCloseDilogClose"
    />
    <trip-start-stop
      :trip="trip"
      :showSSDialog="showStartStopDialog"
      @startStopDialogClose="startStopDialogClose"
    />
  </tbody>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import common from "@/store/common/module/common";
import DutyClose from "@/views/trip/DutyClose";
import TripStartStop from "@/views/trip/TripStartStop";
import { doGet, doPost } from "@/store/common/module/apis";

@Component({
  name: "TripTableRow",
  props: {
    value: {
      default: null,
    },
    selected: {
      default: false,
    },
    createInvoicePayload: {
      default: null,
    },
  },
  components: {
    DutyClose,
    TripStartStop,
  },
})
export default class TripTableRow extends Vue {
  trip = null;
  
  vehicleUpdate = false;
  vehicleUpdateText = null;
  driverUpdate = false;
  attrs = null;
  showDutyCloseDialog = false;
  showCreateInvoice = false;
  showStartStopDialog = false;
  createInvoiceType = "selected";
  selctedTrips = [];
  finalFilters = {};
  payload = {};
  isMail = false;
  invForMail = null;
  showInvoiceDoanload = false;
  showDetail = false;
  clientDue = null;
  supplierDue = null;
  margin = null;
  totalExpenses = null;
  clientAmount = null;
  clientAmountPaid = null;
  supplierAmount = null;
  srcCity = "";
  dstCity = "";

  get loading() {
    return common.loading;
  }

  invDownload() {
    this.$emit("invDownload", this.trip);
  }

  invEmail() {
    this.$emit("invEmail", this.trip);
  }

  changeInvoiceStatus(status) {
    this.$emit("changeInvoiceStatus", this.trip, status);
  }

  recreateInvoice() {
    this.$emit("recreateInvoice", this.trip);
  }

  deleteInvoice() {
    this.$emit("deleteInvoice", this.trip);
  }

  closeDialog(reload) {
    this.showCreateInvoice = false;
    if (reload) this.$emit("reload", true);
    this.showInvoiceDoanload = false;
    this.payload = {};
    this.invForMail = null;
    this.isMail = false;
  }

  createInvoiceDialog() {
    // this.selctedTrips = [];
    // this.selctedTrips.push(this.trip);
    // this.finalFilters = {
    //   vendor_id: this.trip.vendor_id,
    //   client_id: this.trip.corp_id,
    //   invoiceType: 2,
    // };
    const createInvoicePayload = {};
    createInvoicePayload.vendor_id = this.trip.vendor_id;
    createInvoicePayload.client_id = this.trip.corp_id;
    createInvoicePayload.clientEntity_id = this.trip.clientEntity_id;
    createInvoicePayload.vendorEntity_id = this.trip.vendorEntity_id;
    createInvoicePayload.invoiceType = 2;
    createInvoicePayload.trips = [];
    createInvoicePayload.trips.push(this.trip);
    this.$emit("createInvoicePayload", createInvoicePayload);
    // this.showCreateInvoice = true;
  }

  async unassignVehicle(trip) {
    common.setLoading(true);
    try {
      await doGet(`/api/unassign/trip/${trip._id}/vehicle`);
      common.showMessage("Vehicle Unassigned");
      this.$emit("reload", true);
    } catch (e) {
      common.setLoading(false);
      common.setError(e.message);
    }
  }

  dutyCloseDilogClose(reload) {
    this.showDutyCloseDialog = false;
    if (reload) this.$emit("reload", true);
  }

  startStopDialogClose(reload) {
    this.showStartStopDialog = false;
    if (reload) this.$emit("reload", true);
  }

  markCompleted() {
    // this.$emit("markCompleted", this.trip);
    this.showDutyCloseDialog = true;
  }

  // cancelTrip() {
  //   this.$emit("cancelTrip", this.trip);
  // }

  // deleteTrip() {
  //   this.$emit("deleteTrip", this.trip);
  // }

  async cancelTrip() {
    const data = { trip_id: this.trip._id };
    try {
      common.setLoading(true);
      await doPost("/api/trip/mark/cancelled", data);
      this.$emit("reload", true);
      common.setLoading(false);
      this.showPage(this.page);
    } catch (e) {
      common.setLoading(false);
      common.setError(e);
    }
  }

  async deleteTrip() {
    try {
      common.setLoading(true);
      await doGet("/api/trip/" + this.trip._id + "/delete");
      this.$emit("reload", true);
      common.showMessage("Trip Deleted");
      common.setLoading(false);
    } catch (e) {
      common.setLoading(false);
      common.setError(e);
    }
  }

  utilSum(val1, val2) {
    let amount = 0;
    val1 = parseFloat(val1);
    val2 = parseFloat(val2);
    if (val1 && !isNaN(val1)) amount = amount + val1;
    if (val2 && !isNaN(val2)) amount = amount + val2;
    return Math.round(amount);
  }

  mounted() {
    if (this.value && this.value.cargos && this.value.cargos.length > 0 && this.value.cargos[0] && this.value.cargos[0].src && this.value.cargos[0].src.country && this.value.cargos[0].src.city) {
      this.value.src = this.value.cargos[0].src;
    }
    if (this.value && this.value.cargos && this.value.cargos.length > 0 && this.value.cargos[0] && this.value.cargos[0].dst && this.value.cargos[0].dst.country && this.value.cargos[0].dst.city) {
      this.value.dst = this.value.cargos[0].dst;
    }
    if (this.value) this.trip = this.value;

    let clientSubTotal = null;
    let supSubTotal = null;
    //this.clientDue = this.trip['allClientPending']?  this.trip['allClientPending']:null;
    
    if (this.trip && this.trip.clientCargos && this.trip.clientCargos.length > 0) {
      for (let i = 0; i < this.trip.clientCargos.length; i++) {
        if (this.trip.clientCargos[i] && this.trip.clientCargos[i].billing && this.trip.clientCargos[i].billing.fare) {
          if (this.trip.clientCargos[i].billing.fare.total) {
            if (!this.clientAmount) {
              this.clientAmount = this.trip.clientCargos[i].billing.fare.total;
            } else {
              this.clientAmount = this.clientAmount + this.trip.clientCargos[i].billing.fare.total;
            }
          }
          if (this.trip.clientCargos[i].billing.fare.pending) {
            if (!this.clientDue) {
              this.clientDue = this.trip.clientCargos[i].billing.fare.pending;
            } else {
              this.clientDue = this.clientDue + this.trip.clientCargos[i].billing.fare.pending;
            }
          }
          if (this.trip.clientCargos[i].billing.fare.amountPaid) {
            if (!this.clientAmountPaid) {
              this.clientAmountPaid = this.trip.clientCargos[i].billing.fare.amountPaid;
            } else {
              this.clientAmountPaid = this.clientAmountPaid + this.trip.clientCargos[i].billing.fare.amountPaid;
            }
          }
          if (this.trip.clientCargos[i].billing.fare.subTotal) {
            if (!clientSubTotal) {
              clientSubTotal = this.trip.clientCargos[i].billing.fare.subTotal;
            } else {
              clientSubTotal = clientSubTotal + this.trip.clientCargos[i].billing.fare.subTotal;
            }
          }
        }

        const srcCity = [];
        const dstCity = [];

        if (this.trip.clientCargos[i].cargos) {
          for (let j = 0; j < this.trip.clientCargos[i].cargos.length; j++) {
            const element = this.trip.clientCargos[i].cargos[j];
            if (element.src && element.src.city && !srcCity.includes(element.src.city)) {
              srcCity.push(element.src.city);
            }
            if (element.dst && element.dst.city && !srcCity.includes(element.dst.city)) {
              dstCity.push(element.dst.city);
            }
          }
        }
        this.srcCity = srcCity + "";
        this.dstCity = dstCity + "";
      }
    }

    if (this.trip && this.trip.billings) {
      for (let _i = 0; _i < this.trip.billings.length; _i++) {
        if (
          this.trip.billings[_i] &&
          this.trip.billings[_i].client_id &&
          this.trip.billings[_i].client_id == this.trip.myCorp_id
        ) {
          if (this.trip.billings[_i].fare) {
            this.supplierDue = this.utilSum(
              this.supplierDue,
              this.trip.billings[_i].fare.pending
            );
            this.supplierAmount = this.utilSum(
              this.supplierAmount,
              this.trip.billings[_i].fare.total
            );
            supSubTotal = this.utilSum(
              supSubTotal,
              this.trip.billings[_i].fare.subTotal
            );
          }
        }
      }
    }
    if (clientSubTotal && supSubTotal) {
      this.margin = clientSubTotal - supSubTotal;
    } else if (clientSubTotal) {
      this.margin = clientSubTotal;
    }
    if (this.trip.miscExpense) {
      this.totalExpenses = this.trip.miscExpense.total;
    }

    this.margin =
      (this.margin ? this.margin : 0) -
      (this.totalExpenses ? this.totalExpenses : 0);
  }

  // createInvoice(proforma) {
  //   this.$emit("createInvoice", this.trip, true);
  // }

  onDriverChange(newVal) {
    const oldVal = this.trip.driver;
    this.vehicleUpdate = true;
    this.driverUpdate = true;
    if (newVal == null && oldVal != null) {
      this.vehicleUpdateText = this.$i18n.t(
        "Confirm driver to be unassigned !"
      );
    }
    if (newVal != null && oldVal == null) {
      this.vehicleUpdateText = this.$i18n.t("Confirm driver assignment !");
    }
    if (newVal != null && oldVal != null) {
      this.vehicleUpdateText = this.$i18n.t("Confirm driver replace !");
    }
    this.oldVeh = oldVal;
    this.trip.driver = newVal;
  }

  onVehicleUpdateNo() {
    this.vehicleUpdate = false;
    this.trip.vehicle = this.oldVeh;
  }

  onVehicleChange(newVal) {
    const oldVal = this.trip.vehicle;
    this.driverUpdate = false;
    this.vehicleUpdate = true;
    if (newVal == null && oldVal != null) {
      this.vehicleUpdateText = this.$i18n.t(
        "Confirm vehicle to be unassigned !"
      );
    }
    if (newVal != null && oldVal == null) {
      this.vehicleUpdateText = this.$i18n.t("Confirm vehicle assignment !");
    }
    if (newVal != null && oldVal != null) {
      this.vehicleUpdateText = this.$i18n.t("Confirm vehicle replace !");
    }
    this.oldVeh = oldVal;
    this.trip.vehicle = newVal;
  }

  async onRateSelect(rate) {
    if (rate) {
      this.trip.tariffStructure = rate.tariffStructure;
      this.trip.vehicleType = rate.tariffStructure.vehicleType;
      common.setLoading(true);
      try {
        this.trip.fare = await doPost("/api/trip/calc/fare", this.trip);
        common.setLoading(false);
      } catch (e) {
        common.setError(e);
        common.setLoading(false);
      }
    }
  }

  copiedTripPage(val) {
    if (val) {
      this.$router.push({ path: "/trip/" + this.trip._id + "?forCopy=true" });
    }
  }

  async onVehicleUpdateYes(toTripOnly) {
    common.setLoading(true);
    try {
      if (!this.driverUpdate) {
        if (!this.trip.vehicle && this.oldVeh) {
          //This means vehicle is removed by clearable in dropdown
          this.unassignVehicle(this.trip);
          return;
        } else {
          await doGet(
            "/api/assign/trip/" +
              this.trip._id +
              "/vehicle/" +
              this.trip.vehicle._id
          );
        }
      } else {
        let url = "";
        if (toTripOnly) {
          url =
            "/api/trip/" +
            this.trip._id +
            "/driver/" +
            this.trip.driver._id +
            "/assign";
        } else {
          url =
            "/api/trip/" +
            this.trip._id +
            "/driver/" +
            this.trip.driver._id +
            "/assign/vehicle/" +
            this.trip.vehicle._id;
        }
        await doGet(url);
      }
      this.vehicleUpdate = false;
      this.$emit("reload");
      common.showMessage("Vehicle/Driver Assigned.");
    } catch (e) {
      common.setLoading(false);
      common.setError(e.message);
    }
  }

  @Watch("selected")
  onSelectedChange(val) {
    this.trip.selected = val;
  }

  @Watch("value")
  onValueChange(val) {
    this.trip = val;
  }

  onClick() {
    common.setRestore(true);
    this.$router.push({ path: "/trip/" + this.trip._id });
  }

  statusColor() {
    const status = this.trip ? this.trip.status : null;
    if (status == 1) return "red lighten-3";
    if (status == 2) return "purple lighten-4";
    if (status == 3) return "light-blue lighten-4";
    if (status == 4) return "amber";
    if (status == 5) return "red";
    if (status == 6) return "green lighten-3";
    if (status == 7) return "purple lighten-4";
    if (status == 20) return "blue lighten-1";
    if (status == 21) return "green lighten-1";

    return "primary";
  }

  formatDate(date) {
    if (date) {
      const dateStr = date.toString();
      return (
        dateStr.substring(6, 8) +
        "-" +
        dateStr.substring(4, 6) +
        "-" +
        dateStr.substring(0, 4)
      );
    } else {
      return "";
    }
  }

  formattedClientName(clientName){
    if(clientName){
      const clientNameArray = clientName.split(",");
      if(clientNameArray){
        if(clientNameArray.length>1){
          return clientNameArray[0]+" + "+ (clientNameArray.length-1);
        }else{
          return clientNameArray[0];
        }
      }
    }
    return <div></div>;
  }
}
</script>


<style scoped>
.tbody {
  height: 30px;
}
.tbody tr td {
  padding: 0 2px !important;
  cursor: pointer;
}

.tbody tr td .v-input--checkbox {
  padding: 0;
  height: 30px;
  margin-top: 8px;
}

.isActive,
.isActive:hover {
  background-color: #b2dfdb !important;
}
</style>